<template>
	<!-- Left Sidebar  -->
	<div class="left-sidebar">
		<!-- Sidebar scroll-->
		<div class="scroll-sidebar">
			<!-- Sidebar navigation-->
			<nav class="sidebar-nav">
				<ul id="sidebarnav" :style="'height:' + sidebarHeight + 'px'">
					<el-menu
							:default-openeds="openedMenu"
							class="el-menu-vertical"
							:collapse="isCollapse">
						<template v-for="(item, index) in navItems">
							<el-sub-menu v-if="item.name && item.children && AccessAllowed(item,'0')" :index="index.toString()">
								<template #title>
									<i :class="item.icon"></i>
									<span>{{item.name}}</span>
								</template>
                                <template v-for="( childL1, index2 ) in item.children">
									<router-link :to="childL1.url" exact>
                                    	<el-menu-item @click="menuClicked" v-if="AccessAllowed(childL1,index)"  :index="index+'-'+index2" :key="index+'-'+index2">
                                            <i :class="childL1.icon"></i>
                                            <span>{{childL1.name}}</span>
										</el-menu-item>
									</router-link>
                                </template>
							</el-sub-menu>
							<router-link v-else-if="item.name && AccessAllowed(item, '0')" :to="item.url" exact>
								<el-menu-item @click="menuClicked"  :index="index.toString()">
									<i :class="item.icon"></i>
									<span>{{item.name}}</span>
							</el-menu-item>
						</router-link>
						</template>
					</el-menu>
				</ul>
			</nav>
			<!-- End Sidebar navigation -->
		</div>
		<!-- End Sidebar scroll-->
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Util from '../../assets/js/util.js';

	export default {
		data (){
			return {
				openedMenu : ["2","3","4"],
				unqiue : true,
				urlPath : '',
				sidebarHeight: 600
			}
		},
		name: 'sidebar',
		props: {
			navItems: {
				type: Array,
				required: true,
				default: () => []
			},
			isCollapse: {
				type: Boolean,
				required: true,
				default: false
			},
			config: {
				type: Object,
				required: true,
				default: () => {}
			},
			height: {
				type: Number,
				required: true,
				default: 600
			},
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
		},
		watch: {
			height: {
				handler(newVal, oldVal) {
					this.sidebarHeight =  newVal - 57;
				},
				deep: true
			},
		},
		methods: {
			AccessAllowed (item, index) {
				var access = false;
				if (item.children) {
					//need to have access to at least one child or no access to dropdown
					for (let j=0; j < item.children.length; j++) {
						var fullPath = item.children[j].url.substr(1).split('/');
						if (item.children[j].security) {
							for (let i=0; i < this.currentUser.RoleSecurity.length; i++) {
								if (this.currentUser.RoleSecurity[i].Params) {
									if (this.currentUser.RoleSecurity[i].SecurityAreaCode == fullPath[0]) {
										if ((this.currentUser.RoleSecurity[i].Params.Access && this.currentUser.RoleSecurity[i].Params.Access == 'true') || this.currentUser.RoleSecurity[i].Params.ReadAccess) {
											access = true;
											break;
										}
									}
								}
							}
						} else {
							access = true;
						}
					}
				} else {
					if (item.security) {
						var fullPath = item.url.substr(1).split('/');
						if (this.urlPath == item.url.substr(1)) {
							if (this.openedMenu.length == 0) {
								//this.openedMenu = [index.toString()];
								this.urlPath = '';
							}
						}
						for (let i = 0; i < this.currentUser.RoleSecurity.length; i++) {
							if (this.currentUser.RoleSecurity[i].Params) {
								if (this.currentUser.RoleSecurity[i].SecurityAreaCode == fullPath[0]) {
									if ((this.currentUser.RoleSecurity[i].Params.Access && this.currentUser.RoleSecurity[i].Params.Access == 'true') || this.currentUser.RoleSecurity[i].Params.ReadAccess) {
										access = true;
										break;
									}
								}
							}
						}
					} else {
						access = true;
					}
				}
				return access;
			},
			menuClicked(menu) {
				if (Util.isMobile()) {
					document.body.classList.toggle('mini-sidebar');
					let collapse = document.body.classList.contains('mini-sidebar');
					this.$root.$emit('collapse',{isCollapse: collapse});
				}
			}
		},
		mounted() {
			this.sidebarHeight = this.height - 57;
			this.urlPath = this.$route.fullPath.substr(1);
			//if the last path piece is numeric, get rid of it
			let urlParts = this.urlPath.split('/');
			if (!isNaN(urlParts[urlParts.length-1])) {
				urlParts.splice(-1,1);
				this.urlPath = urlParts.join('/');
			}
		}
	}


</script>

<style scoped>
	#sidebarnav {
		overflow-y:scroll;
		height: auto;
		border-right: solid 1px #e6e6e6;
		background-color: #000;
	}
	.el-menu {
		border-right: 0;
		overflow-x: hidden;
		background-color: #000;
	}
	.el-menu-item a {
		display:inline-block;
		width:100%;
		height:100%;
	}
	.el-menu-item {
		padding-right: 0px;
	}
	.el-sub-menu.is-opened {
		border-bottom: 1px solid #666;
	}
	.scroll-sidebar {
		margin-bottom: 5px;
		padding-bottom: 0px;
		border-bottom: solid 1px #666;
	}
	.router-link-active li.el-menu-item, li.el-menu-item.is-active {
    background-color: #ecf5ff;
}
</style>
